import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';
import { IconModule } from 'studio-components/icon/icon.module';
import { IconName } from 'studio-components/icon/types';

@Component({
  selector: 'studio-activation-button',
  standalone: true,
  imports: [CommonModule, ButtonLegacyModule, IconModule],
  templateUrl: './activation-button.component.html',
  styleUrls: ['./activation-button.component.scss'],
})
export class ActivationButtonComponent {
  @Input() public active = false;
  @Input() public iconActive: IconName;
  @Input() public iconInactive: IconName;
  @Input() public showWarning = false;
  @Input() public tooltip: string = null;
}
